import MsalProviderWrapper from "@/components/msal/wrapper"; // import directly

export function DynamicMsalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <MsalProviderWrapper>{children}</MsalProviderWrapper>;
}
